import { render, staticRenderFns } from "./SetSystemMessage.vue?vue&type=template&id=2fddcd30&"
import script from "./SetSystemMessage.vue?vue&type=script&lang=js&"
export * from "./SetSystemMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports